import defaultHook from "./modelMatrixHook.wgsl";

/** @type {import('../ShaderExtension').ShaderExtension[]} */
let _extensions = [];

/**
 * Called by the Renderer when shader extensions are added/removed.
 * @param {import('../ShaderExtension').ShaderExtension[]} extensions
 */
export function setShaderExtensions(extensions) {
  _extensions = extensions;
}

/**
 * Returns the WGSL chunk for the model matrix hook.
 * Checks registered extensions first; falls back to identity
 * (no model matrix modification).
 */
export function getModelMatrixHook() {
  for (const ext of _extensions) {
    const chunk = ext.getModelMatrixHookChunk?.();
    if (chunk) {
      return chunk;
    }
  }
  return defaultHook;
}

export { defaultHook as defaultModelMatrixHook };